import { inject, Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { AddApplication, CheckIsUserHasRegistrationsToExamType, GenerateApplications, GetUserApplications, GetApplicationsByExam } from './application.actions';
import { LoadingState } from '@tsin-core/entities';
import { catchError, tap } from 'rxjs';
import { ApplicationService } from '@tsin-core/services/http/application.service';
import { IExamList } from '@tsin-core/models/exam.model';
import { IApplication, IExamineeShort } from '@tsin-core/models/application.model';

export class ApplicationStateModel {
  public applications: IApplication[] = [];
  public shortApplications: IExamineeShort[] = [];
  public selectedApplication: IApplication | null = null;
  public loading!: LoadingState;
}

const defaults = {
  applications: [],
  shortApplications: [],
  selectedApplication: null,
  loading: LoadingState.notLoading,
};

@State<ApplicationStateModel>({
  name: 'applicationState',
  defaults
})

@Injectable()
export class ApplicationState {

  applicationService: ApplicationService = inject(ApplicationService);


  @Selector()
  static getLoading(state: ApplicationStateModel): LoadingState {
    return state.loading;
  }

  @Selector()
  static getUserApplications(state: ApplicationStateModel): IApplication[] {
    return state.applications;
  }

  @Selector()
  static getUserSelectedApplication(state: ApplicationStateModel): IApplication | null {
    return state.selectedApplication;
  }

  @Selector()
  static getUserShortApplications(state: ApplicationStateModel): IExamineeShort[] {
    return state.shortApplications;
  }


  @Action(GetUserApplications)
  getUserApplications(ctx: StateContext<ApplicationStateModel>, action: GetUserApplications) {
    const state = ctx.getState();
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.applicationService.getUserApplications(action.userId).pipe(
      tap((response: { data: IApplication[] }) => {
        ctx.patchState({
          applications: response.data,
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }


  @Action(GenerateApplications)
  generateApplications(ctx: StateContext<ApplicationStateModel>, action: GenerateApplications) {
    const state = ctx.getState();
    ctx.patchState({ loading: LoadingState.loadingAddUpdate });
    return this.applicationService.generateDryRunApplications(action.payload).pipe(
      tap((generatedResponse: any) => {
        const state = ctx.getState();
        console.log('The applications generated are', generatedResponse)
        ctx.patchState({
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }


  @Action(AddApplication)
  addApplication(ctx: StateContext<ApplicationStateModel>, action: any) {
    const state = ctx.getState();
    ctx.patchState({ loading: LoadingState.loadingAddUpdate });
    return this.applicationService.addExamApplication(action.payload).pipe(
      tap((response: any) => {
        // const applications = [...state.applications, response.data];
        ctx.patchState({
          selectedApplication: response.data,
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }

  @Action(GetApplicationsByExam)
  getApplicationsByExam(ctx: StateContext<ApplicationStateModel>, action: GetApplicationsByExam) {
    const state = ctx.getState();
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.applicationService.getApplicationsByExam(action.payload).pipe(
      tap((response: { data: IExamineeShort[] }) => {
        console.log('Response Data::>>>', response);
        // const shortApplications = [...state.shortApplications, response.data];
        const shortApplications = response.data;
        ctx.patchState({
          shortApplications,
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }

  @Action(CheckIsUserHasRegistrationsToExamType)
  checkIsUserHasRegistrationsToExamType(ctx: StateContext<ApplicationStateModel>, action: CheckIsUserHasRegistrationsToExamType) {
    const state = ctx.getState();
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.applicationService.checkIsUserHasRegistrationsToExamType(action.payload).pipe(
      tap((response: any) => {
        ctx.patchState({
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }
}
